import { Routes, Route, Link, useLocation, useParams } from "react-router-dom";
import Announcements from "./Announcements";
import SectionActivities from "./SectionActivities";
import ConfirmReservation from "./ConfirmReservation";
import Events from "./Events";
// import PostsHeld from "./PostsHeld";
import ProfileSetup from "./ProfileSetup";
import Home from "./Home";
import MakePayment from "./MakePayment";
import ReservationSuccess from "./ReservationSuccess";
import History from "./History";
import club_logo from '../images/riverrun.png'
import { useContext } from "react";
import { UserContext } from "../context/UserContext";
import { MenuContext } from '../context/MenuContext';
import { AiOutlineClose } from "react-icons/ai";
import ScrollToTop from "../ScrollToTop";
import { RiHome6Line } from "react-icons/ri";
import { TbHistoryToggle } from "react-icons/tb";
import { LuSettings } from "react-icons/lu";
import { FaHotjar } from "react-icons/fa";

export default function Dashboard() {
  const location = useLocation();
  const {userProfile, logOutFunction} = useContext(UserContext);
  const { menuOpen, setMenuOpen } = useContext(MenuContext)
  const {apt} = useParams();

  return (
    <div className="flex min-h-screen">
      {/* Sidebar */}
      <div className="py-3 px-0 md:px-1 bg-[#f1f1f1]">
        <aside className={`transition-transform duration-500 fixed lg:relative top-0 bottom-0 h-full z-[50] lg:z-[0] w-64 bg-white text-white p-6 space-y-4 ${menuOpen ? 'flex' : 'hidden lg:flex'} flex-col justify-start`}>
          <div className='flex flex-col justify-start items-center gap-y-2 w-full mt-[10px] mb-[20px]'>
              <div
                  onClick={() => setMenuOpen(false)}
                  className="block lg:hidden btn btn-ghost btn-circle mb-4 self-end fixed"
              >
                  <AiOutlineClose className="h-7 w-7 text-black" />
              </div>
              <img src={club_logo} className="h-auto w-[30%] mx-auto" alt="logo" />
          </div>
          <nav className="flex flex-col space-y-2 gap-y-1">
            <Link to="/dashboard/home" className={`py-2 flex gap-x-3 items-center px-3 hover:text-white hover:bg-secondary rounded-[7px] ${(location.pathname == "/dashboard/home" || location.pathname.startsWith("/dashboard/make-payment")) ? 'bg-primary text-white' : 'text-black'}`} ><RiHome6Line size={20} color={`${(location.pathname == "/dashboard/home" || location.pathname.startsWith("/dashboard/make-payment")) ? '#ffffff' : '#222222'}`} /> Home</Link>
            <Link to="/dashboard/history" className={`py-2 flex gap-x-3 items-center px-3 hover:text-white hover:bg-secondary rounded-[7px] ${(location.pathname == "/dashboard/history" || location.pathname.startsWith("/dashboard/reservation-success")) ? 'bg-primary text-white' : 'text-black'}`} ><TbHistoryToggle size={20} color={`${(location.pathname == "/dashboard/history" || location.pathname.startsWith("/dashboard/reservation-success")) ? '#ffffff' : '#222222'}`} /> My Bookings</Link>
            <Link to="/dashboard/edit-profile" className={`py-2 flex gap-x-3 items-center px-3 hover:text-white hover:bg-secondary rounded-[7px] ${(location.pathname == "/dashboard/edit-profile") ? 'bg-primary text-white' : 'text-black'}`}><LuSettings size={20} color={`${(location.pathname == "/dashboard/edit-profile") ? '#ffffff' : '#222222'}`} /> Set Booking Defaults</Link>
            <div className={`flex items-center justify-start py-2 px-3 hover:bg-secondary rounded-[7px] text-black cursor-pointer`}>
              {/* <FaHotjar size={20} color="#222222" /> */}
              Exclusive Deals
              <div className="ml-2 py-1 px-2 rounded-[5px] bg-primary text-white font-semibold text-xs">
                <a>soon!</a>
              </div>
            </div>
            <div onClick={() => logOutFunction()} className={`py-2 px-3 hover:opacity-[0.8] text-[#ff0000] cursor-pointer hover:font-semibold rounded-[7px]`}>
              Log Out
            </div>
          </nav>
        </aside>
        {menuOpen && <div className={`${menuOpen ? 'flex lg:hidden' : 'hidden'} h-full w-full fixed top-0 bg-[#000000]/50 z-[49]`}>

        </div>}
      </div>

      {/* Main content */}
      <main className="max-h-screen overflow-y-auto flex-1 py-3 px-3 md:px-1 bg-[#f1f1f1]">
        <ScrollToTop />
        <Routes>
          <Route path="home" element={<Home />} />
          <Route path="announcements" element={<Announcements />} />
          <Route path="sections" element={<SectionActivities />} />
          <Route path="confirm-reservation/:apt" element={<ConfirmReservation />} />
          <Route path="reservation-success/:rrr" element={<ReservationSuccess />} />
          <Route path="make-payment" element={<MakePayment />} />
          <Route path="history" element={<History />} />
          <Route path="events" element={<Events />} />
          <Route path="edit-profile" element={<ProfileSetup />} />
          {/* <Route path="posts-held" element={<PostsHeld />} /> */}
        </Routes>
      </main>
    </div>
  );
}
